import { render, staticRenderFns } from "./Presenters.vue?vue&type=template&id=c98ca540&scoped=true&"
import script from "./Presenters.vue?vue&type=script&lang=ts&"
export * from "./Presenters.vue?vue&type=script&lang=ts&"
import style0 from "./Presenters.vue?vue&type=style&index=0&id=c98ca540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98ca540",
  null
  
)

export default component.exports